const AUTO_RELOAD_GUARD_KEY = 'cw:last_auto_reload_at';
const AUTO_RELOAD_COOLDOWN_MS = 60_000;

const isTestEnvironment = () => {
  return (
    typeof process !== 'undefined' &&
    process.env &&
    process.env.NODE_ENV === 'test'
  );
};

const isLocalDevelopment = () => {
  if (isTestEnvironment()) {
    return false;
  }

  const hostname = window.location?.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    hostname === '::1'
  );
};

const readLastAutoReloadAt = () => {
  try {
    const rawValue = window.sessionStorage.getItem(AUTO_RELOAD_GUARD_KEY);
    if (!rawValue) {
      return 0;
    }

    const parsedValue = Number.parseInt(rawValue, 10);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  } catch (_) {
    return 0;
  }
};

const writeLastAutoReloadAt = timestamp => {
  try {
    window.sessionStorage.setItem(AUTO_RELOAD_GUARD_KEY, `${timestamp}`);
  } catch (_) {
    // noop: storage can fail in private mode or strict browser settings
  }
};

export const triggerAutoReload = () => {
  if (isLocalDevelopment()) {
    return false;
  }

  const now = Date.now();
  const lastReloadAt = readLastAutoReloadAt();
  if (lastReloadAt && now - lastReloadAt < AUTO_RELOAD_COOLDOWN_MS) {
    return false;
  }

  writeLastAutoReloadAt(now);
  window.location.reload();
  return true;
};
